<template>
  <el-table
    ref="tableRef"
    :data="tableData"
    v-loading="listLoading"
    border
    fit
    highlight-current-row
    style="width:100%"
    row-key="id"
    default-expand-all
    @row-click="handleRowClick"
  >
    <el-table-column
      v-if="hadSelect"
      :selectable="selectable"
      width="100"
    >
      <template #default="{row}">
        <el-radio
          v-model="selectedRow"
          :label="row.id"
          @change="handleRadioChange(row)"
        >
          {{ '' }}
        </el-radio>
      </template>
    </el-table-column>
    <el-table-column
      :key="'t-column'+index"
      v-for="(item, index) in columnStruct.filter(c => !c.icon)"
      :prop="item.prop"
      :label="item.label"
      :width="item.width"
      :sortable="item.sortable"
      :formatter="item.formatter"
      header-align="left"
      :align="item.align"
      show-overflow-tooltip
    />
    <el-table-column
      :key="'t-column-icon'+index"
      v-for="(item, index) in columnStruct.filter(c => c.icon)"
      :prop="item.prop"
      :label="item.label"
      :width="item.width ? item.width : 120"
      :sortable="item.sortable"
      :formatter="item.formatter"
      header-align="left"
      :align="item.align"
      show-overflow-tooltip
    >
      <template #default="{row}">
        <el-tooltip
          v-if="item.showIcon(row)"
          :content="row[item.iconTooltip]"
          placement="left-end"
        >
          <i
            style="font-size: 20px; color:#ff4949; padding-right: 5px;"
            :class="'el-icon-' + item.icon"
          />
        </el-tooltip>
        <span>{{ item.formatter(row) }}</span>
      </template>
    </el-table-column>
    <el-table-column
      v-if="hadOperate"
      :label="t(operateText)"
      :width="operateColumnWidth"
      show-overflow-tooltip
    >
      <template #default="{row}">
        <slot
          :row="row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, toRefs, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElTable } from 'element-plus'

export default defineComponent({
  props: {
    tableData: {
      type: Array,
      required: true
    },
    columnStruct: {
      type: Array,
      required: true
    },
    listLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    hadOperate: {
      type: Boolean,
      required: false,
      default: true
    },
    operateText: {
      type: String,
      required: false,
      default: 'common.operate'
    },
    operateColumnWidth: {
      type: Number,
      required: false,
      default: 180
    },
    hadSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    selectable: {
      type: Function,
      required: false,
      default: () => true
    },
    defaultSelect: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const { t } = useI18n()
    const tableRef = ref(ElTable)
    const dataMap = reactive({
      selectedRow: 0,
      defaultSelect: 0
    })
    const handleRadioChange = (row: any) => {
      dataMap.selectedRow = row.id
    }
    const handleRowClick = (row: any) => {
      dataMap.selectedRow = row.id
    }
    const setSelectedRow = (id: any) => {
      dataMap.selectedRow = id
      dataMap.defaultSelect = id
    }
    const getSelectionRow = () => {
      return dataMap.selectedRow || null
    }
    const clearSelection = () => {
      if (tableRef.value) {
        tableRef.value.clearSelection()
        dataMap.selectedRow = 0
      }
    }
    onMounted(() => {
      dataMap.selectedRow = props.defaultSelect
    })
    watch(() => dataMap.defaultSelect, value => {
      dataMap.selectedRow = value
    })
    return {
      t,
      tableRef,
      handleRadioChange,
      handleRowClick,
      setSelectedRow,
      getSelectionRow,
      clearSelection,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>

</style>
